<template lang="pug">
#modal-reanalise-certificacao
    el-dialog(
        title='Gerar nova análise',
        width='500px',
        top='5vh',
        :visible='show',
        @close='closeDialog'
    )
        BlocoListarAtivasCertificao(
            @emitIdsCertificacaoTipo='idsCertificacaoTipo',
            :checked-default-by-name='checked'
        )
        hr
        p
            b Território:
            |
            | {{ rowInfo.geometrias[0].nomeTerritorio }}
        p
            b Localidade:
            |
            | {{ rowInfo.geometrias[0].municipioTerritorioNome }} / {{ rowInfo.geometrias[0].estadoTerritorioSigla }}
        p.margin-p
            b CAR(s) vinculado(s):
            ul.lista-car
                li.lista(v-for='car in rowInfo.cars' :key='car.idCar')
                    span {{ car.codigo }}
        p.margin-p.margin-p-block
            b Representante(s):
            ul.lista-representante
                li.lista(v-for='rep in rowInfo.representantes' :key='rep.idRepresentante')
                    span {{ rep.nomeRepresentante }}
        .d-flex.flex-direction.justify-content-between.py-3
            el-button(slot='footer', size='mini', @click='closeDialog') Voltar
            el-button(
                slot='footer',
                size='mini',
                type='primary',
                @click='realizarAnalise'
            ) Continuar
</template>

<script>
import BlocoListarAtivasCertificao from '@/components/certificacao/BlocoListarAtivasCertificao.vue';
import CertificacaoService from '@/services/CertificacaoService';
export default {
    name: 'ModalGerarAnalise',
    components: {
        BlocoListarAtivasCertificao
    },
    emits: ['update:show'],
    props: {
        show: {
            type: Boolean,
            required: true
        },
        rowInfo: {
            type: Object,
            required: true
        },

        checked: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            certificacao: {
                idsTerritorio: [],
                idsCertificacaoTipo: []
            }
        };
    },

    methods: {
        closeDialog() {
            this.clearFields();
            this.$emit('update:show', false);
        },
        idsCertificacaoTipo(idsCertificacaoTipo) {
            this.certificacao.idsCertificacaoTipo = idsCertificacaoTipo.idsTipo;
        },
        clearFields() {
            this.certificacao.idsTerritorio = [];
        },
        atualizarTabela() {
            this.$emit('atualizarTabela');
        },
        async realizarAnalise() {
            if (!this.rowInfo.geometrias.length) {
                this.$notify.error({
                    message:
                        'Necessário inserir ao menos um território para realizar análise.'
                });
                return;
            }
            if (!this.certificacao.idsCertificacaoTipo.length) {
                this.$notify.error({
                    message:
                        'Necessário selecionar ao menos um tipo de certificação para realizar análise.'
                });
                return;
            }

            this.certificacao.idsTerritorio = this.rowInfo.geometrias.map(
                territorio => territorio.nomeTerritorio
            );

            try {
                await CertificacaoService.InserirCertificacaoTerritorio({
                    idTerritorio: this.certificacao.idsTerritorio,
                    idCertificacaoTipo: this.certificacao.idsCertificacaoTipo
                });
                this.$notify.success({
                    message: 'Certificações enviadas para análise com sucesso!'
                });
                this.atualizarTabela();
                this.closeDialog();
                this.$router.push({ name: 'Certificacao' });
            } catch (error) {
                this.$notify.error({
                    message:
                        'Erro na requisição de enviar os territórios certificados.'
                });
                this.clearFields();
            }
        }
    }
};
</script>

<style lang="scss">
.el-dialog__header {
    padding: 20px;
    padding-bottom: 10px;
    background: #f6f6f6;
    color: #3b3b3b;
    padding-bottom: 12px;
    padding-top: 12px;
}
.el-dialog__body {
    padding: 20px 20px 30px 20px;
    word-break: break-word;
}
.el-dialog__headerbtn {
    top: 10px;
}
.el-dialog__headerbtn:hover .el-icon-close {
    color: #ffffff;
}

.el-dialog__title {
    color: var(--primary);
    font-weight: bold;
}
</style>
